import {Component, EventEmitter, Input, Output} from '@angular/core';
import {JackingFieldTemplateEditor} from '../../../../../../../models/jacking-v2/jacking.models';

@Component({
  selector: 'jacking-field-integer',
  templateUrl: 'jacking-field-integer.component.html'
})
export class JackingFieldIntegerComponent {
  @Input() field: JackingFieldTemplateEditor;
  @Input() value: number | null;
  @Input() isComputed = false;
  @Input() isReadOnly = false;
  @Output() valueChange = new EventEmitter<any>();


  private getRange(): { min: number | null; max: number | null } {
    const min = this.field?.minValue ?? null;
    const max = this.field?.maxValue ?? null;
    return { min, max };
  }

  private isAllowedEditKey(e: KeyboardEvent): boolean {
    const k = e.key;
    return (
      k === 'Backspace' ||
      k === 'Delete' ||
      k === 'Tab' ||
      k === 'Escape' ||
      k === 'Enter' ||
      k === 'ArrowLeft' ||
      k === 'ArrowRight' ||
      k === 'ArrowUp' ||
      k === 'ArrowDown' ||
      k === 'Home' ||
      k === 'End' ||
      (e.ctrlKey || e.metaKey)
    );
  }

  private buildNextText(input: HTMLInputElement, insertText: string): string {
    const current = input.value ?? '';
    const start = input.selectionStart ?? current.length;
    const end = input.selectionEnd ?? current.length;
    return current.slice(0, start) + insertText + current.slice(end);
  }

  private wouldBeInRangeInteger(nextText: string): boolean {
    const trimmed = nextText.trim();
    if (trimmed === '') { return true; }

    const { min, max } = this.getRange();

    if (trimmed === '-') { return min != null ? min < 0 : true; }

    if (!/^-?\d+$/.test(trimmed)) { return false; }

    const n = parseInt(trimmed, 10);
    if (Number.isNaN(n)) { return false; }

    if (min != null && n < min) { return false; }
    if (max != null && n > max) { return false; }

    return true;
  }

  onIntegerKeyDown(e: KeyboardEvent): void {
    if (this.field?.readOnly || this.isComputed) { return; }
    if (this.isAllowedEditKey(e)) { return; }

    const input = e.target as HTMLInputElement;
    const { min } = this.getRange();

    const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
    const isMinus = e.key === '-' && (min == null || min < 0);

    if (!isDigit && !isMinus) {
      e.preventDefault();
      return;
    }

    const nextText = this.buildNextText(input, e.key);
    if (!this.wouldBeInRangeInteger(nextText)) {
      e.preventDefault();
    }
  }

  onIntegerPaste(e: ClipboardEvent): void {
    if (this.field?.readOnly || this.isComputed) { return; }

    const input = e.target as HTMLInputElement;
    const { min } = this.getRange();

    const raw = e.clipboardData?.getData('text') ?? '';
    if (!raw) { return; }

    let cleaned = raw.replace(/[^\d-]/g, '');
    if (cleaned.includes('-')) {
      cleaned = cleaned.replace(/-/g, '');
      if (min == null || min < 0) { cleaned = '-' + cleaned; }
    }

    const nextText = this.buildNextText(input, cleaned);
    if (!this.wouldBeInRangeInteger(nextText)) {
      e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-field-component/sub-components/jacking-field-integer/jacking-field-integer.component.ts